import { ReactNode, createContext, useContext, useMemo, useState } from 'react';

import { NavbarScrollContextType } from './type';

const NavbarScrollContext = createContext<NavbarScrollContextType>({
  scrolledContent: null,
  setScrolledContent: () => {},
  hideCurrencySelector: false,
  setHideCurrencySelector: () => {},
});

export const NavbarScrollProvider = ({ children }: { children: ReactNode }) => {
  const [scrolledContent, setScrolledContent] = useState<ReactNode | null>(
    null,
  );
  const [hideCurrencySelector, setHideCurrencySelector] = useState(false);
  const value = useMemo(
    () => ({
      scrolledContent,
      setScrolledContent,
      hideCurrencySelector,
      setHideCurrencySelector,
    }),
    [scrolledContent, hideCurrencySelector],
  );
  return (
    <NavbarScrollContext.Provider value={value}>
      {children}
    </NavbarScrollContext.Provider>
  );
};

export const useNavbarScroll = () => useContext(NavbarScrollContext);
